import { useQuery } from '@tanstack/react-query'
import { createRoute } from '@tanstack/react-router'
import { EmployeeInvitations } from '../components/employee-invitations/invitations'
import { SettingsLayout } from '../components/settings-layout'
import { api } from '../lib/api'
import { Route as rootRoute } from './__root'

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/settings/invitations',
  component: Page,
})
function Page() {
  const me = useQuery({ queryKey: ['auth', 'me'], queryFn: () => api.me() })
  return (
    <SettingsLayout title="Mitarbeiter & Einladungen">
      {me.isLoading ? (
        <p>Wird geladen …</p>
      ) : me.data?.user?.role === 'admin' ? (
        <EmployeeInvitations />
      ) : (
        <p>Nur für angemeldete Administratoren.</p>
      )}
    </SettingsLayout>
  )
}
